import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let EFacilitySource;
(function (EFacilitySource) {
  EFacilitySource["Sms"] = "sms";
  EFacilitySource["Voice"] = "voice";
  EFacilitySource["Email"] = "email";
  EFacilitySource["None"] = "none";
})(EFacilitySource || (EFacilitySource = {}));
export const fieldsFacility = _extends({}, fieldsIBaseModel, {
  address: {
    type: 'Text'
  },
  alternativeName: {
    type: 'Text'
  },
  alternativePhone: {
    type: 'Text'
  },
  city: {
    type: 'Text'
  },
  country: {
    type: 'Text'
  },
  externalId: {
    type: 'Object'
  },
  externalRawSource: {
    type: 'Unknown'
  },
  fax: {
    type: 'Text'
  },
  integrator: {
    type: 'Option',
    values: EExternalSource
  },
  name: {
    type: 'Text'
  },
  phone: {
    type: 'Text'
  },
  phonetic: {
    type: 'Text'
  },
  postcode: {
    type: 'Text'
  },
  searchIds: {
    type: 'Text',
    array: true
  },
  setting: {
    type: 'ID',
    ref: EModel.Setting
  },
  settings: {
    type: 'Object'
  },
  specialInstructions: {
    type: 'Text'
  },
  state: {
    type: 'Text'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  visible: {
    type: 'Boolean'
  }
});